import { addZeroEntriesForMissingDates, removeTimezoneFromDateString, } from '@fourthwall/module-analytics';
export const mapCurrentProfitDataToChartSeriesData = (currentProfitData, params) => {
    if (!currentProfitData)
        return [];
    const { timestamps, values } = addZeroEntriesForMissingDates(currentProfitData, params);
    return timestamps.map((value, index) => ({
        date: new Date(removeTimezoneFromDateString(value)),
        value: values[index],
    }));
};
